export class ChartValue {
    public className: string;
    public value: number;
    public name?: string;
}
